import { Button, styled, Table, Typography } from "@mui/material";

export const StyledButton = styled(Button)({
  justifyContent: "start",
  // width: "100%"
});

export const Label = styled(Typography)({
  // width : "200px"
});

export const StyledTable = styled(Table)(({ theme }) => ({
  "& .MuiTableHead-root": {
    "& .MuiTableCell-root": {
      backgroundColor: theme.palette.background.paper,
    },
  },
}));
